import store from '@/store'
import http_fuction from '@/api/network/materials'
import mqtt_fuction from '@/api/slicer/materials'
import common from '@/utils/common.js'

async function materialsAll (funStr, ...data) {
  const type = store.getters.GET_PRINTER_TYPE == 'cloud' ? 'http' : 'mqtt'
  const curPrinter = store.getters.GET_CUR_PRINTER
  let state = null
  if (store.getters.GET_PRINTER_TYPE == 'cloud') {
    state = common.formatterStatus(
      curPrinter?.device_status,
      curPrinter?.is_printing
    )
    if (state.toLowerCase() != 'busy' && state.toLowerCase() != 'free') {
      return
    }
  }
  const functionMap = {
    http: http_fuction,
    mqtt: mqtt_fuction
  };
  const setAutoFeedFunction = functionMap[type][`${type}_${funStr}`];

  if (!setAutoFeedFunction) {
    throw new Error(`Unsupported printer type: ${type}`);
  }

  return await setAutoFeedFunction(...data);
}

// General-purpose function to handle setting auto feed
export default materialsAll

